import { gql } from '@apollo/client'

const GET_DELIVERY_PRICING_BANDS = gql`
  query GetDeliveryPricingBands($storeId: uuid!, $orderType: OrderType!) {
    getDeliveryPricingBands(storeId: $storeId, orderType: $orderType) {
      id
      lowerThreshold
      upperThreshold
      percentageDiscount
    }
  }
`

const GET_MERCHANT_PRICING_BANDS = gql`
  query GetMerchantPricingBands($merchantId: uuid!) {
    merchants(where: { id: { _eq: $merchantId } }) {
      stores(where: { archived_at: { _is_null: true } }) {
        store_order_type_settings {
          store_id
          order_type
          store_delivery_settings {
            delivery_pricing_bands
          }
        }
      }
    }
  }
`

const UPSERT_DELIVERY_PRICING_BANDS = gql`
  mutation UpsertDeliveryPricingBands(
    $storeId: uuid!
    $orderType: OrderType!
    $deliveryPricingBands: [DeliveryPricingBandParam]!
  ) {
    setDeliveryPricingBands(
      deliveryPricingBands: $deliveryPricingBands
      orderType: $orderType
      storeId: $storeId
    ) {
      id
      lowerThreshold
      upperThreshold
      percentageDiscount
    }
  }
`

export {
  GET_DELIVERY_PRICING_BANDS,
  GET_MERCHANT_PRICING_BANDS,
  UPSERT_DELIVERY_PRICING_BANDS
}
